import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    EntryOptions,
    PropertyDefinition,
} from "app/library/layout-builder";
import { CultureRoadV2Props } from "./types";
import { MetaTypeEnum } from "app/shared";
import { CultureRoadPropertyDefinitions } from 'components/cms/definitions';

export class CultureRoadV2Definitions extends CmsReactComponent<CultureRoadV2Props> {
    static defaultProps = {};

    static schemaName = "culture-road-v2";

    static propertyDefinitions: PropertyDefinition[] = CultureRoadPropertyDefinitions;

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [
                MetaTypeEnum.Text,
                MetaTypeEnum.TextArea,
                MetaTypeEnum.SingleImage,
                MetaTypeEnum.Editor,
                MetaTypeEnum.Number,
                MetaTypeEnum.Link,
            ],
        },
        mappingFields: [
            {
                name: "title",
                text: "Rota Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "positionX",
                text: "Rota Konum Sol",
                types: [MetaTypeEnum.Text, MetaTypeEnum.Number],
            },
            {
                name: "positionY",
                text: "Rota Konum Üst",
                types: [MetaTypeEnum.Text, MetaTypeEnum.Number],
            },
            {
                name: "poster",
                text: "Rota Görsel",
                types: [MetaTypeEnum.SingleImage],
            },
            {
                name: "direction",
                text: "Rota Görsel",
                types: [MetaTypeEnum.Dropdown],
            },
            {
                name: "description",
                text: "Rota Açıklaması",
                types: [MetaTypeEnum.Editor, MetaTypeEnum.TextArea, MetaTypeEnum.Text],
            },
            {
                name: "anchor",
                text: "Rota Sayfa Linki",
                types: [MetaTypeEnum.Link],
            },
            {
                name: "facebook",
                text: "Facebook Linki",
                types: [MetaTypeEnum.Text],
            },
            {
                name: "twitter",
                text: "Twitter Linki",
                types: [MetaTypeEnum.Text],
            },
            {
                name: "instagram",
                text: "Instagram Linki",
                types: [MetaTypeEnum.Text],
            },
            {
                name: "googleAddress",
                text: "Rota Google Map Konumu",
                types: [MetaTypeEnum.Text],
            }
        ],
    };
}
